export enum FeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}
